import {
  Brightness5,
  DarkMode,
  Logout,
  Settings,
  TextFormat
} from '@mui/icons-material'
import {
  Box,
  List,
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText
} from '@mui/material'
import React from 'react'
import { connect } from 'react-redux'
import { useNavigate } from 'react-router-dom'
import AccountSettings from 'components/account-settings'
import NivosModal from 'components/nivos-modal'
import { NIVOS_LANGUAGES } from 'constants/layout'
import { LIGHT_MODE, NIGHT_MODE } from 'constants/theme'
import {
  Operations as LayoutOperations,
  operations as layoutOperations
} from 'states/dux/layout/operations'
import { Payload as LayoutPayload } from 'states/dux/layout/types'
import {
  Operations as ThemeOperations,
  operations as themeOperations
} from 'states/dux/theme/operations'
import { Payload as ThemePayload } from 'states/dux/theme/types'
import {
  Operations as UserOperations,
  operations as userOperations
} from 'states/dux/user/operations'
import { Payload as UserPayload } from 'states/dux/user/types'
import State from 'states/types'
import { clearSessionTokens, mapOperationsToDispatchProps } from 'utils/common'

interface StateProps {
  theme: ThemePayload
  layout: LayoutPayload
  user: UserPayload
}

interface DispatchProps {
  operations: {
    theme: ThemeOperations
    layout: LayoutOperations
    user: UserOperations
  }
}

type AppProps = StateProps & DispatchProps

const NivosAccountMenuFC: React.FC<any> = (props: AppProps) => {
  const { theme, layout, operations } = props
  const [nightMode, setNightMode] = React.useState(
    JSON.stringify(theme) === JSON.stringify(NIGHT_MODE)
  )
  const [settingsModal, openSettingsModal] = React.useState(false)

  const navigate = useNavigate()

  React.useEffect(() => {
    operations.theme.set(nightMode ? NIGHT_MODE : LIGHT_MODE)
  }, [nightMode])

  return (
    <Box
      display={'flex'}
      flexDirection={'column'}
      justifyContent={'flex-start'}
      padding={2}
    >
      <NivosModal
        title={layout.language.translations.accountSettings}
        open={settingsModal}
        setOpen={openSettingsModal}
      >
        <AccountSettings />
      </NivosModal>
      <List>
        <ListItem>
          <ListItemButton onClick={() => openSettingsModal(true)}>
            <ListItemIcon>
              <Settings color={'primary'} />
            </ListItemIcon>
            <ListItemText
              primary={layout.language.translations.accountSettings}
            />
          </ListItemButton>
        </ListItem>
        <ListItem>
          <ListItemButton onClick={() => setNightMode(!nightMode)}>
            <ListItemIcon>
              {!nightMode && <Brightness5 color={'primary'} />}
              {nightMode && <DarkMode color={'primary'} />}
            </ListItemIcon>
            <ListItemText
              primary={
                nightMode
                  ? layout.language.translations.nightMode
                  : layout.language.translations.lightMode
              }
            />
          </ListItemButton>
        </ListItem>
        <ListItem>
          <ListItemButton
            onClick={() =>
              operations.layout.update({
                language:
                  layout.language.name === 'English'
                    ? NIVOS_LANGUAGES.fr
                    : NIVOS_LANGUAGES.eng
              })
            }
          >
            <ListItemIcon>
              <TextFormat color={'primary'} />
            </ListItemIcon>
            <ListItemText primary={layout.language.name} />
          </ListItemButton>
        </ListItem>
        <ListItem>
          <ListItemButton
            onClick={() => {
              clearSessionTokens()
              navigate('/')
            }}
          >
            <ListItemIcon>
              <Logout color={'primary'} />
            </ListItemIcon>
            <ListItemText primary={layout.language.translations.logout} />
          </ListItemButton>
        </ListItem>
      </List>
    </Box>
  )
}

const mapStateToProps = (state: State): StateProps => {
  return {
    theme: state.theme,
    layout: state.layout,
    user: state.user
  }
}

const mapDispatchToProps = mapOperationsToDispatchProps({
  theme: themeOperations,
  layout: layoutOperations,
  user: userOperations
})

const NivosAccountMenu = connect(
  mapStateToProps,
  mapDispatchToProps
)(NivosAccountMenuFC) as React.FC

export default NivosAccountMenu
